import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=222e285f&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222e285f')) {
      api.createRecord('222e285f', component.options)
    } else {
      api.reload('222e285f', component.options)
    }
    module.hot.accept("./Article.vue?vue&type=template&id=222e285f&", function () {
      api.rerender('222e285f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/components/Article.vue"
export default component.exports